import type { AnnotationSource } from './imageAnnotations';
export function imageFromClick(target: EventTarget | null): AnnotationSource | null {
  if (!(target instanceof HTMLImageElement)) return null;
  const link = target.closest('a');
  const candidate = link?.href || target.src;
  try {
    const url = new URL(candidate, window.location.href);
    if (!['https:', 'http:', 'blob:'].includes(url.protocol)) return null;
    return { url: url.href, name: target.alt || decodeURIComponent(url.pathname.split('/').at(-1) || 'изображение') };
  } catch { return null; }
}
